import React, { useState, useEffect, useRef } from "react";
import { NavLink, withRouter } from "react-router-dom";
// css
import "./Header.css";
// assets
import logo from "assets/Images/icons/newLogo1.png";
import menu from "assets/Images/icons/menu.png";
import cancel from "assets/Images/icons/cancel.png";
// import MessageIcon from "assets/Images/icons/Message.png"
// import compassIcon from "assets/Images/icons/compass.png"
// import heartIcon from "assets/Images/icons/heart.png"
// component
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import CustomModel from "Utills/Model/CustomModel";
import { connect } from 'react-redux';
import { logout_user } from "store/actions";
import { useNotifyContext } from "context/notifyContext"
import {  Avatar } from "@material-ui/core"

const Header = (props) => {
  let user = props.current_user;
  // 
  const [show, setshow] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  // ========= notification context
  const { set_notify, } = useNotifyContext()
  // Reference for elements
  const main_header = useRef(null);
  const menuRef = useRef(null);
  const [dropDown, setDropDown] = useState(null);

  //===================== handle block/unblock scroll events when Menu opened =======================
  const handleScroll = () => {
    setshow(false);
    document.body.classList.remove("no_scroll");
  };
  // ====================== open Side Menu =========================
  const openMenu = () => {
    setshow(true)
    document.body.classList.add("no_scroll")
  };
  // ====================== Close Side Menu =========================
  const closeMenu = () => {
    setshow(false);
    document.body.classList.remove("no_scroll");
  };

  //============= Handle Profile Menu ==============
  const handleDropDown = () => {
    setDropDown(!dropDown);
  };

  //===== Hide menu when side bar open ===========
  const hideBoatMenu = () => {
    setDropDown(false);
  };

  // ========== check for Menus ==============
  useEffect(() => {
    function boathandler(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        hideBoatMenu();
      }
    }
    if (dropDown) {
      document.addEventListener("click", boathandler);
      return () => document.removeEventListener("click", boathandler);
    }
  }, [dropDown]);


  //======================== This is all about for event page header ==================================
  // useEffect(() => {
  // const listenScrollEvent = (event) => {
  //   if (props?.location.pathname === '/events') {
  //     if (window.scrollY > window.innerHeight - 50) {
  //       main_header?.current?.classList.remove('transparent_header')
  //     } else {
  //       main_header?.current?.classList.add('transparent_header')
  //     }
  //   }

  // }
  // if (props?.location.pathname === '/events') {
  //   if (window.scrollY > window.innerHeight - 50) {
  //     main_header?.current?.classList.remove('transparent_header')
  //   } else {
  //     main_header?.current?.classList.add('transparent_header')

  //   }
  // } else {
  //   main_header?.current?.classList.remove('transparent_header')
  // }
  // window.addEventListener('scroll', listenScrollEvent);
  //   return () =>
  //     // window.removeEventListener('scroll', listenScrollEvent);
  // }, [props.location]);


  return (
    <>
      {show &&
        <div onClick={() => setshow(false)} className="shadow-of-sidebar"></div>}
      {/*  */}
      {user && user?.isAuth  &&
        <div className={` ${show ? 'd-none' : 'mob-v'}`}>
          <button className="header-profile-btn" ref={menuRef}>
            <div onClick={handleDropDown} className="cs-avatar">
              <Avatar src={user?.profileImg ? user?.profileImg : "."} alt={user.name?.slice(0, 1)} />
            </div>
            {/* profile dropdown */}
            {dropDown &&
              <div className="profile-drop-down">
                <ul>
                  <NavLink exact to="/"
                    onClick={() => {
                      setDropDown(false);
                      closeMenu()
                    }}
                  >
                    Book Now
                  </NavLink>  <NavLink exact to="/contact"
                    onClick={() => {
                      setDropDown(false);
                      closeMenu()
                    }}
                  >
                    Contact Us
                  </NavLink>
                  {/* <li
                    onClick={() => {
                      setDropDown(false);
                      closeMenu()
                    }}
                  >
                    Notification
                  </li> */}
                  {/* <NavLink exact to="/favorites"
                    onClick={() => {
                      setDropDown(false);
                      closeMenu()
                    }}
                  >
                    Favorites
                  </NavLink> */}
                  {/* {user?.is_captain === true ?
                    <>
                      <NavLink activeClassName="nav-activee" to='/myListings'
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                      >My fleet
                      </NavLink>
                      <NavLink
                        activeClassName="nav-activee"
                        to="/AddBoat"
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                      >Add listing
                      </NavLink>
                    </> : null} */}
                  {/* <NavLink
                    activeClassName="nav-activee"
                    onClick={() => {
                      setDropDown(false);
                      closeMenu()
                    }}
                    to='/profile'>
                    Account
                  </NavLink> */}
                  {/* {!user.is_captain ? <Divider className='bg-dark' /> : null}
                  <li
                    onClick={() => {
                      setDropDown(false);
                      closeMenu()
                    }}
                  >
                    Help
                  </li> */}
                  <li className={!user.is_captain ? "text-muted" : ''}
                    onClick={() => {
                      props.logout_user();
                      setDropDown(false);
                      closeMenu()
                      set_notify({ open: true, msg: "Logout successfully.", type: "success" });
                    }
                    }>
                    Sign Out
                  </li>
                </ul>
              </div>
            }
          </button>

        </div>
      }
      {/* Web header */}
      <header ref={main_header} className={`main-web-header `}>
        <NavLink exact to="/">
          <img
            style={{ display: !show ? "" : "none" }}
            className="mb mb_logo"
            src={logo}
            alt="logo"
          />
        </NavLink>
        <div className={!show ? "close_nav" : "open_nav"}>
          <div className="nav_brand" onClick={() => { document.body.classList.remove("no_scroll"); setshow(false) }}>
            <NavLink exact to="/" className="d-flex justify-content-start align-items-center">
              <img className="header-logo" src={logo} alt="logo" />
              <span className="text-white  border border-top-0 border-end-0 border-bottom-0 d-inline-block ps-2 ms-2">
              
          Booking beyond imagination
              </span>
            </NavLink>
          </div>
          <div className="nav_links">
            <NavLink
              exact
              to="/"
              onClick={() => {
                handleScroll();
              }}
            >
              Home
            </NavLink>
            {/* <NavLink
              exact
              to="/listing"
              onClick={() => {
                handleScroll();
              }}
            >
              Yachts
            </NavLink> */}
            {/* <NavLink
              exact
              to="/experience"
              onClick={() => {
                handleScroll();
              }}
            >
              Experience
            </NavLink>
            <NavLink
              exact
              to="/events"
              onClick={() => {
                handleScroll();
              }}
            >
              Events
            </NavLink> */}
            {/* <NavLink
              exact
              to="/blogs"
              onClick={() => {
                handleScroll();
              }}
            >
              Blogs
            </NavLink> */}
            <NavLink
              exact
              to="/about"
              onClick={() => {
                handleScroll();
              }}
            >
              About
            </NavLink>
            <div className="separator"></div>
            {/* {user && user?.isAuth  ?
              <div className="my-account-header">
                <button className="header-profile-btn desk-v" ref={menuRef}>
                  <div onClick={handleDropDown} className="cs-avatar">
                    <Avatar src={user?.profileImg ? user?.profileImg : "."} alt={user.name?.slice(0, 1)} />
                  </div>
                  {dropDown &&
                    <div className="profile-drop-down">
                      <ul>
                        <li
                          onClick={() => {
                            setDropDown(false);
                            closeMenu()
                          }}
                        >
                          Notification
                        </li>
                        <NavLink exact to="/favorites"
                          onClick={() => {
                            setDropDown(false);
                            closeMenu()
                          }}
                        >
                          Favorites
                        </NavLink>
                        {user?.is_captain === true ?
                          <>
                            <NavLink activeClassName="nav-activee" to='/myListings'
                              onClick={() => {
                                setDropDown(false);
                                closeMenu()
                              }}
                            >My fleet
                            </NavLink>
                            <NavLink
                              activeClassName="nav-activee"
                              to="/AddBoat"
                              onClick={() => {
                                setDropDown(false);
                                closeMenu()
                              }}
                            >Add listing
                            </NavLink>
                          </> : null}
                        <NavLink
                          activeClassName="nav-activee"
                          onClick={() => {
                            setDropDown(false);
                            closeMenu()
                          }}
                          to='/profile'>
                          Account
                        </NavLink>
                        {!user.is_captain ? <Divider className='bg-dark' /> : null}
                        <li
                          onClick={() => {
                            setDropDown(false);
                            closeMenu()
                          }}
                        >
                          Help
                        </li>
                        <li className={!user.is_captain ? "text-muted" : ''}
                          onClick={() => {
                            props.logout_user();
                            setDropDown(false);
                            closeMenu()
                            set_notify({ open: true, msg: "Logout successfully.", type: "success" });
                          }
                          }>
                          Sign Out
                        </li>
                      </ul>
                    </div>
                  }
                </button>
              </div>
              :
              <>
                <div className="nav_buttons">
                  <button
                    onClick={() => { setShowPopup(true); handleScroll(); }}
                    className="sigin_in_btn"
                  >
                    Sign in
                  </button>
                  <NavLink onClick={() => {
                    handleScroll();
                  }} to="/signup" className="sign_up_btn text-white">Sign up</NavLink>
                </div>
              </>
            } */}


            {/* =============== important  */}
            {user && user?.isAuth  ?
              <div className="my-account-header">
                {/* <div className="my-acc-btns-wrap">
                <NavLink exact to="/manageTrips"
                  className="with-notify"
                  onClick={() => {
                    handleScroll();
                  }}
                >
                  <img src={compassIcon} alt="" />
                </NavLink>
                <NavLink exact to="/favorites"
                  className="with-notify"
                  onClick={() => {
                    handleScroll();
                  }}>
                  <img src={heartIcon} alt="" />
                </NavLink>
                <NavLink exact to="/inbox"
                  className="with-notify"
                  onClick={() => {
                    handleScroll();
                  }}>
                  <img src={MessageIcon} alt="" />
                </NavLink>
              </div> */}
                <button className="header-profile-btn desk-v" ref={menuRef}>
                  <div onClick={handleDropDown} className="cs-avatar">
                    <Avatar src={user?.profileImg ? user?.profileImg : "."} alt={user.name?.slice(0, 1)} />
                  </div>
                  {dropDown &&
                    <div className="profile-drop-down">
                      <ul>

                        {/* ============== after ============ */}
                        <NavLink exact to="/manageTrips"
                          onClick={() => {
                            setDropDown(false);
                            closeMenu()
                          }}
                        >
                          Bookings
                        </NavLink>  
                        <NavLink exact to="/favorites"
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                      >
                        Favorites
                      </NavLink> 
                        <NavLink exact to="/contact"
                          onClick={() => {
                            setDropDown(false);
                            closeMenu()
                          }}
                        >
                         Help
                        </NavLink>
                        
                        {/* ============== before ============ */}
                        {/* <li
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                      >
                        Notification
                      </li>
                      <NavLink exact to="/favorites"
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                      >
                        Favorites
                      </NavLink> */}
                        {/* {user?.is_captain === true ?
                        <>
                          <NavLink activeClassName="nav-activee" to='/myListings'
                            onClick={() => {
                              setDropDown(false);
                              closeMenu()
                            }}
                          >My fleet
                          </NavLink>
                          <NavLink
                            activeClassName="nav-activee"
                            to="/AddBoat"
                            onClick={() => {
                              setDropDown(false);
                              closeMenu()
                            }}
                          >Add listing
                          </NavLink>
                        </> : null} */}
                        {/* <NavLink
                        activeClassName="nav-activee"
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                        to='/profile'>
                        Account
                      </NavLink> */}
                        {/* {!user.is_captain ? <Divider className='bg-dark' /> : null} */}
                        {/* <li
                        onClick={() => {
                          setDropDown(false);
                          closeMenu()
                        }}
                      >
                        Help
                      </li> */}
                        <li
                          // className={!user.is_captain ? "text-muted" : ''}
                          className={"text-muted"}
                          onClick={() => {
                            props.logout_user();
                            setDropDown(false);
                            closeMenu()
                            set_notify({ open: true, msg: "Logout successfully.", type: "success" });
                          }
                          }>
                          Sign Out
                        </li>
                      </ul>
                    </div>
                  }
                </button>
              </div>
              :
              <div className="nav_buttons">
                <button
                  onClick={() => { setShowPopup(true); handleScroll(); }}
                  className="sigin_in_btn"
                >
                  Sign in
                </button>
                <NavLink onClick={() => {
                  handleScroll();
                }} to="/signup" className="sign_up_btn text-white">Sign up</NavLink>
              </div>

            }

          </div>
        </div>
        <img className="mb menu_btn"
          onClick={
            () => {
              !show ?
                openMenu()
                :
                closeMenu()

            }
          }
          src={!show ? menu : cancel}
          alt="..."
        />
      </header>

      {/* login modal popUP */}
      <CustomModel openPopup={showPopup} setOpenPopup={setShowPopup} >
        <SiginInPopup
          closeModel={setShowPopup}
        />
      </CustomModel>
    </>
  );
};

// Redux config
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  logout_user: () => dispatch(logout_user()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
